import { Firestore } from 'firebase/firestore';
import { CompanyType, InventoryClass } from '../enums';
import yup from './yup';

const getCompanySchema = (
  firestore: Firestore,
  companyType = CompanyType.Customer
) => {
  const schema = {
    class: yup.mixed<InventoryClass>().required(),
    name: yup
      .string()
      .required()
      .max(255)
      .unique(firestore, 'Companies', 'nameNormalized', true),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any;

  if (companyType !== CompanyType.CorporateCompany) {
    schema['accountNumber'] = yup
      .string()
      .required()
      .unique(firestore, 'Companies', 'accountNumber', false);
    schema['shippingDocEmailRecipient'] = yup
      .array()
      .of(yup.string().max(255).email())
      .nullable();
  } else {
    schema['canSeeCSA'] = yup.boolean().when(['canSeeUL'], {
      is: (canSeeUL: boolean) => !canSeeUL,
      then: (schema) =>
        schema.notOneOf([false], 'common.validations.fieldRequired'),
    });
  }

  if (companyType !== CompanyType.Agency) {
    schema['code'] = yup
      .string()
      .nullable()
      .max(4)
      .unique(firestore, 'Companies', 'codeNormalized', true);
  }

  return yup.object(schema);
};

export default getCompanySchema;
